import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import budgetType from "@/views/module/budget/settings/budgetType.vue";
import budgetHead  from "@/views/module/budget/settings/budgetHead.vue";
import  budgetSubHead  from "@/views/module/budget/settings/budjetSubHead.vue";
import budget from "@/views/module/budget/budgets/budget.vue";
import budgetList from "@/views/module/budget/budgets/budgetList.vue";

export default [
{
    path: "/budget",
    name: "budget",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Budget",
    },
    children: [
        {
            path: "budget-types",
            name: "budget-types",
            meta: {
                breadcrumb: ["Budget", "Types"],
            },
            component: budgetType,
        },
        {
            path: "budget-heads",
            name: "budget-heads",
            meta: {
                breadcrumb: ["Budget", "Heads"],
            },
            component: budgetHead,
        },
        {
            path: "budget-sub-heads",
            name: "budget-sub-heads",
            meta: {
                breadcrumb: ["Budget", "Sub Heads"],
            },
            component: budgetSubHead,
        },
        {
            path: "budget-create/:id?",
            name: "budget-create",
            meta: {
                breadcrumb: ["Budget", "Create Budget"],
            },
            component: budget,
        },
        {
            path: "budget-records",
            name: "budget-records",
            meta: {
                breadcrumb: ["Budget", "Budget List"],
            },
            component: budgetList,
        },
    ],
  },
];
